import type { AssetImageSource } from './get_asset_image_source';

/**
 * `cache: 'reload'` avoids the image's non-CORS response already cached by its
 * on-page `<img>` display, which would otherwise fail the cross-origin read.
 */
const fetchImageBlob = async (url: string): Promise<Blob> => {
  const response = await fetch(url, { mode: 'cors', cache: 'reload' });
  if (!response.ok) {
    throw new Error(`Image request failed with ${response.status}`);
  }
  return response.blob();
};

/** Reads the bytes behind a picked asset's image, retrying with its fallback. */
export const fetchImageSourceBlob = async (
  source: AssetImageSource,
): Promise<Blob> => {
  try {
    return await fetchImageBlob(source.url);
  } catch (error) {
    // Proxies live on their own storage, which is not guaranteed to allow
    // cross-origin reads; fall back to the keyframe rather than fail outright.
    if (!source.fallbackUrl) {
      throw error;
    }
    return fetchImageBlob(source.fallbackUrl);
  }
};
